import { ApiBase } from "@/api/ApiBase";

export type GrupoUtilizador = "ADMIN" | "SADMIN" | "OPERADOR";
export type Genero = "M" | "F" | "Indefinido";
export type EstadoUtilizador = "Autorizado" | "Bloqueado";

export interface UtilizadorResumo {
  id: number;
  nome: string;
  estado: EstadoUtilizador;
  grupo: GrupoUtilizador;
  telefone: string;
  foto: string | null;
  dataCriacao: string;
}

export interface UtilizadorDetalhe {
  id: number;
  nome: string;
  telefone: string;
  username: string;
  genero: Genero | null;
  estado: EstadoUtilizador | null;
  grupo: GrupoUtilizador;
  permissoesBackoffice: string | null;
  permissoesPOS: string | null;
  foto: string | null;
  dataCriacao: string;
}

export interface UtilizadorFormBase {
  nome: string;
  genero: Genero;
  telefone: string;
  permissoesBackoffice: string[];
  permissoesPOS: string[];
}

export interface DadosCriarUtilizador extends UtilizadorFormBase {
  estado: EstadoUtilizador;
}

export interface DadosEditarUtilizador extends UtilizadorFormBase {
  id: number;
  username: string;
  estado: EstadoUtilizador | null;
}

export interface UtilizadorResponse {
  msg: string;
  tipo: "sucesso" | "erro";
}

export interface HistoricoItem {
  id: number;
  descricao: string;
  dispositivo: string | null;
  informacaoAdicional: string | null;
  dataCriacao: string;
}

export interface HistoricoUtilizador {
  sessoes: HistoricoItem[];
  operacoes: HistoricoItem[];
}

function anexarPermissoes(
  fd: FormData,
  campo: "permissoesBackoffice[]" | "permissoesPOS[]",
  codigos: string[],
) {
  codigos.forEach((codigo) => fd.append(campo, codigo));
}

export class UtilizadoresApi extends ApiBase {
  listar(): Promise<UtilizadorResumo[]> {
    return this.http.put<UtilizadorResumo[]>(
      "/api/comerciante/utilizador/lista-by-comerciante",
    );
  }

  detalhes(id: number): Promise<UtilizadorDetalhe> {
    return this.http.put<UtilizadorDetalhe>(
      `/api/comerciante/utilizador/detalhes/${id}`,
    );
  }

  historico(id: number): Promise<HistoricoUtilizador> {
    return this.http.put<HistoricoUtilizador>(
      `/api/comerciante/utilizador/historico/${id}`,
    );
  }

  adicionar(
    dados: DadosCriarUtilizador,
    senha: string,
    senha2: string,
    foto: File | null,
  ): Promise<UtilizadorResponse> {
    const fd = new FormData();
    fd.append("nome", dados.nome);
    fd.append("genero", dados.genero);
    fd.append("estado", dados.estado);
    fd.append("telefone", dados.telefone);
    fd.append("SENHA", senha);
    fd.append("SENHA2", senha2);
    anexarPermissoes(fd, "permissoesBackoffice[]", dados.permissoesBackoffice);
    anexarPermissoes(fd, "permissoesPOS[]", dados.permissoesPOS);
    if (foto) fd.append("fotoUtilizador", foto);

    return this.http.postMultipart<UtilizadorResponse>(
      "/api/comerciante/utilizador/add-app",
      fd,
    );
  }

  editar(
    dados: DadosEditarUtilizador,
    senha: string,
    foto: File | null,
  ): Promise<UtilizadorResponse> {
    const fd = new FormData();
    fd.append("id", String(dados.id));
    fd.append("nome", dados.nome);
    fd.append("genero", dados.genero);
    if (dados.estado) fd.append("estado", dados.estado);
    fd.append("telefone", dados.telefone);
    fd.append("username", dados.username);
    if (senha) fd.append("SENHA", senha);
    anexarPermissoes(fd, "permissoesBackoffice[]", dados.permissoesBackoffice);
    anexarPermissoes(fd, "permissoesPOS[]", dados.permissoesPOS);
    if (foto) fd.append("fotoUtilizador", foto);

    return this.http.postMultipart<UtilizadorResponse>(
      "/api/comerciante/utilizador/edit-app",
      fd,
    );
  }

  apagar(id: number, nome: string): Promise<UtilizadorResponse> {
    return this.http.post<UtilizadorResponse>(
      "/api/comerciante/utilizador/delete-app",
      { id: String(id), nome },
    );
  }
}
